module.exports = __webpack_public_path__ + "8fc4ff12b5ebf860bfe3ed32389e58a9.pdf";